import {
  onlineManager,
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { createIDBPersister } from "./persister";

// Setup react-query QueryClient with default options for stale time and GC
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      networkMode: "always", // always serve cached data; re-fetch when able
    },
    mutations: {
      // Pause mutations when offline and automatically replay them once the
      // network comes back, rather than immediately throwing a network error.
      networkMode: "offlineFirst",
      retry: 3,
      retryDelay: (attempt) => Math.min(1000 * Math.pow(2, attempt), 10_000),
    },
  },
});

// When the browser/device comes back online, immediately flush any mutations
// that were queued while offline so they don't wait for the next user action.
onlineManager.subscribe((isOnline) => {
  if (isOnline) {
    void queryClient.resumePausedMutations();
  }
});

// Create an IndexedDB-backed persister for the pantry cache.
// Exported so PersistQueryClientProvider in main.tsx can reference it directly.
const persister = createIDBPersister("pantry-cache");

export { persister, queryClient, useMutation, useQuery, useQueryClient };
